export default function CustomerAuxInfoFilter(vdCustomerAddressFilter) {
  'ngInject'

  function getAuxInfo(customer) {
    if (customer.mobile) {
      return customer.mobile
    }

    if (customer.phone) {
      return customer.phone
    }

    if (customer.email) {
      return customer.email
    }

    const address = vdCustomerAddressFilter(customer)

    if (address) {
      return address
    }

    if (customer.dob) {
      return customer.dob
    }
  }
  /**
   * Get's auxiliary customer information. Returns the customer's code and one other piece of indentifying
   * information (which is evaluated in order of priority).
   *
   * @function
   *
   * @param  {Customer} customer
   *         The customer to get the name of
   *
   * @return {String} The customer code and one piece of indentifying information (if available)
   */
  return function (customer) {
    if (!customer) {
      return
    }

    const auxInfo = []

    const customerCode = customer.customer_code
    const additionalInfo = getAuxInfo(customer)

    if (customerCode) {
      auxInfo.push(customerCode.trim())
    }

    if (additionalInfo) {
      auxInfo.push(additionalInfo.trim())
    }

    return auxInfo.join(' | ')
  }
}
